import { render, staticRenderFns } from "./StatisticsMarksGeneralIndex.vue?vue&type=template&id=98381f00"
import script from "./StatisticsMarksGeneralIndex.vue?vue&type=script&lang=js"
export * from "./StatisticsMarksGeneralIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports